/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M31.4 16c0 .6-.4 1-1 1H17v13.4c0 .6-.4 1-1 1s-1-.4-1-1V17H1.6c-.6 0-1-.4-1-1s.4-1 1-1H15V1.6c0-.6.4-1 1-1s1 .4 1 1V15h13.4c.5 0 1 .4 1 1z"/>'
  }
})
